import Axios from "axios";

const baseURL = process.env.BARRAMUNDI;

export default {
    getDeviceLists(params) {
        return Axios.get(`${baseURL}account/devices`, {
            params
        }).then(response => response);
    },
    saveAnalyzerDevice(params) {
        return Axios.put(`${baseURL}account/save-analyzer`, params).then(response => response);
    },
    saveSettingsDevice(params) {
        return Axios.post(`${baseURL}account/save-device`, params).then(response => response);
    },
    saveSettingsAddNewDevice(params) { 
        return Axios.post(`${baseURL}account/create-device`, params).then(response => response);
    },
    deleteSettingsDevice({ id }) {
        return Axios.delete(`${baseURL}account/devices/${id}`);
    }
};
